/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import { createUseStyles } from "react-jss";

import Header from "./header";
import "../scss/main.scss";

const useStyles = createUseStyles({
  "@global": {
    "#gatsby-focus-wrapper": {
      height: "100%"
    }
  },
  footer: {
    composes: ["page--footer", "py-4"],
    background: "#343a40"
  },
  "footer--text-copyright": {
    color: "#f8f9fa",
    fontSize: "12px",
  }
})

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const styles = useStyles();

  return (
      <div className="page--wrapper">
        <Header siteTitle={data.site.siteMetadata.title} />
        <div className="page--body">
          <main className="container pb-4">{children}</main>
        </div>
        <footer className={styles.footer}>
          <div className="container">
            <p className={styles["footer--text-copyright"]}>Copyright &copy; 2020 Thomas Nicolosi, All rights reserved.</p>
          </div>
        </footer>
      </div>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
